import { useEffect } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import InstallHero from "./components/InstallHero";
import InstallIntro from "./components/InstallIntro";
import InstallTypes from "./components/InstallTypes";
import InstallGallery from "./components/InstallGallery";
import InstallWhyChoose from "./components/InstallWhyChoose";
import InstallCta from "./components/InstallCta";

export default function InstalacionAires() {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <InstallHero />
        <InstallIntro />
        <InstallTypes />
        <InstallGallery />
        <InstallWhyChoose />
        <InstallCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}